import React from "react";
import styles from "../components/laymanComp_css/LaymanPage9.module.css";
import { Link } from "@mui/material";
import Common_html from "./Common_html";
import BlockData from "../../../layman-explanation-json/zodiac_planetary_powers.json";

export default function LaymanPage_Zodiac_Planetary_Powers() {
  return (
    <>
    <Common_html BlockData={BlockData} />
    </>
  );
}